import React, { Component } from 'react';
import history from './History';
import './RequestForm.css'
import { withRouter, useParams, useLocation } from "react-router-dom";

function RequestForm(props) {
  const location = useLocation();
  const { from } = location.state || {};
  const { topic } = useParams();
  return <RequestOnTopic {...props} topic={topic} from={from} />;
}

export default withRouter(RequestForm);

export class RequestOnTopic extends Component {

  constructor(props) {
    super(props);

    const topicMap = {
      generalinquiry: '00 - General Inquiry',
      deltabundle:    '01 - Delta Offers & Pricing',
      effluxbundle:   '02 - Efflux Offers & Pricing',
      deltatrial:     '03 - Delta Free Trial',
      effluxtrial:    '04 - Efflux Free Trial'
    };

    const topicTitle = topicMap[this.props.topic] || '00 - General Inquiry';
    const limit = 1024;
    this.state = { topic: this.props.topic, limit: limit, sizeRemaining: limit, topicTitle: topicTitle, body: '' };
  }


  onMessageBodyChange(e) {
    const inputText = e.target.value;
    const sizeRemaining = this.state.limit - inputText.length;
    this.setState({ sizeRemaining: sizeRemaining, body: e.target.value });
  }

  submitMessage(e) {
    const apiUrl = process.env.REACT_APP_API_URL;
    fetch(`${apiUrl}/message`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/text'
      },
      body: "_topic=" + encodeURIComponent(this.state.topicTitle) + "&_body=" + encodeURIComponent(this.state.body)
    }).then(res => {
      if (res.ok) {
        return res.text();
      } else {
        throw new Error("Submission failed w/ response: " + res.statusText + ". Please try again later.");
      }
    }).then(confirmCode => {
      alert("Submission succeeded w/ Confirmation Code " + confirmCode + " which is also emailed out. Please use the code for future reference.")
      const fromPath = this.props.from;
      if (typeof fromPath === 'string' && !fromPath.startsWith('/requestform'))
        history.push(fromPath);
      else
        history.push('/product');
    }).catch(error => {
      alert(error);
    });
  }

  render() {
    if (!this.props.isLoggedIn) {
      history.push('/login/' + this.props.topic, { from: history.location.pathname })
    }
   
    return (
      <div className="message-container">
        <div className='message-banner-text'>
          <h2>Megadigm<span className="trademark">&reg; Message Center</span></h2>
        </div>
        <div className="box-container">
          <div className="header">Please type in Message Body below and then Submit:</div>
          <div className="box">
            <div className="input-group">
              <label htmlFor="topic" className="input-label">Topic</label>
              <input type="text" id="topic" name="topic" className="topic-input" value={this.state.topicTitle} readOnly={true} disabled/>
            </div>
            <div className="input-group">
              <label htmlFor="message-body" className="input-label" style={{ display: 'block', marginTop: '16px' }}>Message Body</label>
              <textarea id="message-body" name="messageBody" maxLength={this.state.limit} rows={8} className="message-body-input"
                placeholder="Enter s pecific message here..." onChange={this.onMessageBodyChange.bind(this)} />
              <label className="input-label" style={{ color: this.state.sizeRemaining == 0 ? 'red' : 'black'}} >{this.state.sizeRemaining} chars remaining of max {this.state.limit}</label>
            </div>
            <div className="submit-group">
              <button type="button" className="submit-btn" onClick={this.submitMessage.bind(this)} disabled={this.state.sizeRemaining == this.state.limit}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}